import clsx from 'clsx';
import React from 'react';
import PropTypes from 'prop-types';
import elementType from 'prop-types-extra/lib/elementType';
import { prefix, splitBsPropsAndOmit } from '../bootstrap/utils/bootstrapUtils';
import { useTabContainer, TabContentProvider } from '../bootstrap/context/TabContext';
import { jsx as _jsx } from "react/jsx-runtime";
class TabContent extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.handlePaneEnter = this.handlePaneEnter.bind(this);
    this.handlePaneExited = this.handlePaneExited.bind(this);

    // Active entries in state will be `null` unless `animation` is set. Need
    // to track active child in case keys swap and the active child changes
    // but the active key does not.
    this.state = {
      activeKey: null,
      activeChild: null
    };
  }
  componentDidUpdate(prevProps) {
    if (!this.props.animation && prevProps.animation && this.state.activeChild) {
      this.setState({
        activeKey: null,
        activeChild: null
      });
    }
  }
  componentWillUnmount() {
    this.isUnmounted = true;
  }
  handlePaneEnter(child, childKey) {
    if (!this.props.animation) {
      return false;
    }

    // It's possible that this child should be transitioning out.
    if (childKey !== this.getContainerActiveKey()) {
      return false;
    }
    this.setState({
      activeKey: childKey,
      activeChild: child
    });
    return true;
  }
  handlePaneExited(child) {
    // This might happen as everything is unmounting.
    if (this.isUnmounted) {
      return;
    }
    this.setState(_ref => {
      let {
        activeChild
      } = _ref;
      if (activeChild !== child) {
        return null;
      }
      return {
        activeKey: null,
        activeChild: null
      };
    });
  }
  getContainerActiveKey() {
    return this.props.tabContainer?.activeKey;
  }
  render() {
    const {
      componentClass: Component,
      className,
      ...props
    } = this.props;
    const [bsProps, elementProps] = splitBsPropsAndOmit(props, ['animation', 'mountOnEnter', 'unmountOnExit', 'tabContainer']);
    const {
      bsClass,
      animation,
      mountOnEnter,
      unmountOnExit
    } = this.props;
    const stateActiveKey = this.state.activeKey;
    const containerActiveKey = this.getContainerActiveKey();
    const activeKey = stateActiveKey != null ? stateActiveKey : containerActiveKey;
    const exiting = stateActiveKey != null && stateActiveKey !== containerActiveKey;
    const contextValue = {
      bsClass,
      animation,
      activeKey,
      mountOnEnter,
      unmountOnExit,
      onPaneEnter: this.handlePaneEnter,
      onPaneExited: this.handlePaneExited,
      exiting
    };
    return /*#__PURE__*/_jsx(TabContentProvider, {
      value: contextValue,
      children: /*#__PURE__*/_jsx(Component, {
        ...elementProps,
        className: clsx(className, prefix(bsProps, 'content'))
      })
    });
  }
}
TabContent.defaultProps = {
  componentClass: 'div',
  animation: true,
  mountOnEnter: false,
  unmountOnExit: false,
  bsClass: 'tab'
};
const TabContentWithContext = /*#__PURE__*/React.forwardRef((props, ref) => {
  const tabContainer = useTabContainer();
  return /*#__PURE__*/_jsx(TabContent, {
    ...props,
    tabContainer: tabContainer,
    ref: ref
  });
});
TabContentWithContext.displayName = 'TabContent';
export default TabContentWithContext;